import { render, staticRenderFns } from "./UserViewUserStrategyCard.vue?vue&type=template&id=27098eec&"
import script from "./UserViewUserStrategyCard.vue?vue&type=script&lang=js&"
export * from "./UserViewUserStrategyCard.vue?vue&type=script&lang=js&"
import style0 from "./UserViewUserStrategyCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports